module.exports = firebase;


//////////////////
// WEBPACK FOOTER
// external "firebase"
// module id = 0
// module chunks = 1